import { useAtomValue } from 'jotai/utils';
import { Typography, Space } from 'antd';

import supportQuestionsAtomFamily from '../../data/atoms/support-questions';

import './index.css'
import { Heading } from '../typography';
import MetadataFactory from '../../utils/MetadataFactory';
import Metadata from '../metadata';
import Accordion from '../accordion';

function FAQPanel({ page, separateSections, showCategoryHeading = true, categoryHeadingLevel = 2, includeMetadata = false }) {
  const questionsByCategory = useAtomValue(supportQuestionsAtomFamily(page));

  if (!questionsByCategory.data || questionsByCategory.data.length === 0) return null;

  return (
    <Space direction="vertical" className="bccampus-faq" size={24}>
      {includeMetadata === true &&
        <Metadata jsonld={MetadataFactory({
          "@type": "FAQPage",
          "mainEntity": questionsByCategory.data.reduce((prev, current) => {
            if (current.questions.length > 0) {
              current.questions.forEach(entry =>
                prev.push({
                  "@type": "Question",
                  "name": entry.question,
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": entry.answer
                  }
                })
              )
            }

            return prev;

          }, [])
        })} />
      }
      {
        questionsByCategory.data.map(category => (
          category.questions.length > 0
            ?
            <div key={`category-${category.id}`} className="bccampus-faq-category">
              {showCategoryHeading &&
                <Heading level={categoryHeadingLevel}>{category.heading}</Heading>
              }
              <Accordion
                separateSections={separateSections}
                keyPrefix="question-"
              >
                {
                  category.questions.map(item => (
                    <Accordion.Panel key={`question-${item.id}`} id={`question-${item.id}`}
                      header={<Typography.Text style={{ fontSize: "1.15em" }}>{item.question}</Typography.Text>}
                    >
                      <div className="bccampus-cms-content" dangerouslySetInnerHTML={{ __html: item.answer }} />
                    </Accordion.Panel>
                  ))
                }
              </Accordion>
            </div>
            : null
        ))
      }
    </Space>
  )
}

export default FAQPanel;
